import _slicedToArray from "/var/jenkins_home/workspace/web_bieyangapp_review_page@2/product-search/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
export var create = function create() {
  return [1, 0, 0, 1, 0, 0];
};
export var getTranslateX = function getTranslateX(m) {
  return m[4];
};
export var getTranslateY = function getTranslateY(m) {
  return m[5];
};
export var getScaleX = function getScaleX(m) {
  return m[0];
};
export var getScaleY = function getScaleY(m) {
  return m[3];
};
export var translate = function translate(m, x, y) {
  return multiply([1, 0, 0, 1, x, y], m);
};
export var scale = function scale(m, scaleX) {
  var scaleY = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : scaleX;
  return multiply([scaleX, 0, 0, scaleY, 0, 0], m);
};
export var apply = function apply(m, _ref) {
  var _ref2 = _slicedToArray(_ref, 2),
      ox = _ref2[0],
      oy = _ref2[1];

  return [m[0] * ox + m[2] * oy + m[4], m[1] * ox + m[3] * oy + m[5]];
};
export var multiply = function multiply(m1, m2) {
  return [m1[0] * m2[0] + m1[2] * m2[1], m1[1] * m2[0] + m1[3] * m2[1], m1[0] * m2[2] + m1[2] * m2[3], m1[1] * m2[2] + m1[3] * m2[3], m1[0] * m2[4] + m1[2] * m2[5] + m1[4], m1[1] * m2[4] + m1[3] * m2[5] + m1[5]];
};